export default __webpack_public_path__ + "static/media/(3).130a5b8d.jpeg";